import * as $ from 'jquery';
import * as fileInput from 'Modules/fileInput';
import * as formValidation from 'Modules/formValidation';


declare const grecaptcha: any;

namespace BHW.askAQuestion {
	const POST_ASKAQUESTION = '/api/salesforce/ask-a-question';	
	const POST_CASE_UPLOAD_FILE = '/api/salesforce/case-upload-file';	

	let $form = $('form');
	let $aaqform = (document.getElementById('aaq-form') as HTMLFormElement);
	let $alertSuccess = $('.js-alert-success');
	let $alertDanger = $('.js-alert-danger');
	let $alertDangerFields = $('.js-alert-danger-fields');
	let $errorList = $('.js-issues-need-correction');
	let $firstName = $('#first-name');
	let $lastName = $('#last-name');
	let $email = $('#email');
	let $companyName = $('#company-name');
	let $address = $('#address');
	let $address2 = $('#address2');
	let $country = $('#country');
	let $city = $('#city');
	let $state = $('#state');
	let $province = $('#province');
	let $postalCode = $('#postal-code');
	let $phone = $('#phone');
	let $fax = $('#fax');
	let $helpCategory = $('#help-category');
	let $describeYou = $('#describe-you');
	let $originalOwner = $('[name="original-owner"]');
	let $productCategory = $('#product-category');
	let $model = $('#product-number');
	let $purchaseYear = $('#purchase-year');
	let $currentlyBuy = $('[name="currently-buy"]');
	let $estimatedsales = $('#estimated-sales');
	let $focusedOn = $('[name="focusedOn"]');
	let $productInterests = $('[name="productInterests"]');
	let $InterestedIn = $('#interestedIn');
	let $filesRequired = $('#filesRequired');
	let $questionComment = $('#question-comment');
	let $uploadPhoto = (<any>document.getElementById('upload-photo'));
	let $submit = $('#submit');
	let $pleaseWait = $('#please-wait');
	let $loadIndicator = $('.js-load-indicator');
	let uploadPhotoRequired = "Upload files Required";
	let uploadFiles = [];

	let constraints = {
		'first-name': {
			presence: {
				allowEmpty: false,
				message: '^' + 'First Name Required'
			}
		},
		'last-name': {
			presence: {
				allowEmpty: false,
				message: '^' + 'Last Name Required'
			}
		},
		'email': {
			presence: {
				allowEmpty: false,
				message: '^' + 'Email Required'
			},
			email: {
				message: '^' + 'Email Invalid'
			}
		},
		'address': {
			presence: {
				allowEmpty: false,
				message: '^' + 'Address Required'
			}
		},
		'address2': {
			presence: false
		},
		'country': {
			presence: {
				allowEmpty: false,
				message: '^' + 'Country Required'
			}
		},
		'city': {
			presence: {
				allowEmpty: false,
				message: '^' + 'City Required'
			}
		},
		'state': {
			presence: {
				allowEmpty: false,
				message: '^' + 'State/Province Required'
			}
		},		
		'postal-code': {
			presence: {
				allowEmpty: false,
				message: '^' + 'Postal Code Required'
			}
		},
		'phone': {
			presence: {
				allowEmpty: false,
				message: '^' + 'Phone Required'
			},
			format: {
				pattern: /^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/,
				message: '^' + 'Phone Invalid'
			}
		},
		'original-owner': {
			presence: {
				allowEmpty: false,
				message: '^' + 'Original Owner Required'
			}
		},
		'product-category': {
			presence: {
				allowEmpty: false,
				message: '^' + 'Product Category Required'
			}
		},
		'purchase-year': {
			presence: {
				allowEmpty: false,
				message: '^' + 'Purchase Year Required'
			},
			numericality: {
				onlyInteger: true,
				greaterThan: 0,
				message: '^' + 'Purchase Year Invalid'
			}
		},
		'describe-you': {
			presence: {
				message: '^' + 'Describes you Required'
			}
		},
		'help-category': {
			presence: {
				message: '^' + 'Help Category Required'
			}
		},
		'question-comment': {
			presence: false
		},
		'recaptcha-token': {
			presence: {
				allowEmpty: false,
				message: '^' + 'Captcha Required'
			}
		}
	};

	let salesConstraints = {
		'first-name': {
			presence: {
				allowEmpty: false,
				message: '^' + 'First Name Required'
			}
		},
		'last-name': {
			presence: {
				allowEmpty: false,
				message: '^' + 'Last Name Required'
			}
		},
		'email': {
			presence: {
				allowEmpty: false,
				message: '^' + 'Email Required'
			},
			email: {
				message: '^' + 'Email Invalid'
			}
		},
		'address': {
			presence: {
				allowEmpty: false,
				message: '^' + 'Address Required'
			}
		},
		'address2': {
			presence: false
		},
		'country': {
			presence: {
				allowEmpty: false,
				message: '^' + 'Country Required'
			}
		},
		'city': {
			presence: {
				allowEmpty: false,
				message: '^' + 'City Required'
			}
		},
		'state': {
			presence: {
				allowEmpty: false,
				message: '^' + 'State/Province Required'
			}
		},	
		'postal-code': {
			presence: {
				allowEmpty: false,
				message: '^' + 'Postal Code Required'
			}
		},
		'phone': {
			presence: {
				allowEmpty: false,
				message: '^' + 'Phone Required'
			},
			format: {
				pattern: /^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/,
				message: '^' + 'Phone Invalid'
			}
		},
		'describe-you': {
			presence: {
				message: '^' + 'Describes you is Required'
			}
		},
		'help-category': {
			presence: {
				message: '^' + 'Help Category Required'
			}
		},
		'estimated-sales': {
			presence: {
				message: '^' + 'Estimated Annual Sales Volume Required'
			}
		},
		'currently-buy': {
			presence: {
				message: '^' + 'Currently Buying Products is Required'
			}
		},
		'productInterests': {
			presence: {
				message: '^' + 'Interested Spectrum Hardware Brands is Required'
			}
		},
		'focusedOn': {
			presence: {
				message: '^' + 'Focused on is Required'
			}
		},
		'interestedIn': {
			presence: {
				message: '^' + 'Select a value for interested in'
			}
		},
		'question-comment': {
			presence: false
		},
		'recaptcha-token': {
			presence: {
				allowEmpty: false,
				message: '^' + 'Captcha Required'
			}
		}
	};

	let validateField = function () {
		$(this).addClass('dirty');
		if (formValidation.validateWrapper({
			constraints: $helpCategory.val() =="sales" ? salesConstraints : constraints,
			values: {
				'first-name': $firstName.val(),
				'last-name': $lastName.val(),
				'email': $email.val(),
				'address': $address.val(),
				'address2': $address2.val(),
				'country': $country.val(),
				'city': $city.val(),
				'state': $state.val(),
				'province': $province.val(),
				'postal-code': $postalCode.val(),
				 'phone': $phone.val(),
				'describe-you': $describeYou.val(),
				'original-owner': $originalOwner.filter(':checked').val(),
				'product-category': $productCategory.val(),
				'model': $model.val(),
				'purchase-year': $purchaseYear.val(),
				'help-category': $helpCategory.val(),
				'currently-buy': $currentlyBuy.val(),
				'estimated-sales': $estimatedsales.val(),
				'focusedOn': $focusedOn.val(),
				'productInterests': $productInterests.val(),
				'interestedIn': $InterestedIn.val(),
				'question-comment': $questionComment.val(),
				'recaptcha-token': grecaptcha.getResponse()
			}
		})) {
			// disable submit button
		}
	};

	let setupHandlers = function () {
		//waiting a second here so that the fileinput.ts binding that happens can be turned off.
		setTimeout(function () {
			$('input[type=file]').off('change.file');
		$('#upload-photo').on('change.upload', function (e) {
				var $value = $(this).siblings('.js-file-input-value');
				var $this = $(this);
				var $eTarget = <any>e.target;
				if (((this) as any).files && ((this) as any).files[0]) {
					if ($eTarget.files.length <= 5) {
						uploadFiles = [];
						var output = [];
						for (var i = 0; i < $eTarget.files.length; i++) {
							uploadFiles.push($eTarget.files[i]);
							let removeLink = '<i data-fileid=\"' + i + '\" class="icon icon-times file-input-close js-remove-file" title="Remove Image"></i>';
							output.push('<li><strong>' + $eTarget.files[i].name + '</strong>' + removeLink + '</li> ');
						}
						$value.html('');
						$value.append(output.join(""));
						if ($this.data("accept")) {
							let fileAssocArray = $this.data("accept").split(',');
							for (var i = 0; i < $eTarget.files.length; i++) {
								let fileName = $eTarget.files[i].name;
								let fileExt = (fileName.split(/[. ]+/).pop()).toLowerCase();
								if (fileAssocArray.indexOf(`.${fileExt}`) > -1) {
									validateField();
								}
								else {
									$value.html('');
									alert(`.${fileExt} files are not allowed. Please choose one of the following file types: (${fileAssocArray})`);
								}
							}
						}
					}
					else {
						alert(`Cannot upload more than 5 files`);
					}
				} else {
					$value.html('');
				}
			});
		}, 1000);

		$('body').on('click.register', '.js-reset-file', function (e) {
			validateField();
			e.preventDefault();
		});

		// remove clicked file
		$('body').on('click.register', '.js-remove-file', function (e) {
			e.preventDefault();
			var fileName = $(this).parent().children("strong").text();
			for (let i = 0; i < uploadFiles.length; ++i) {
				if (uploadFiles[i].name == fileName) {
					uploadFiles.splice(i, 1);
				}
			}
			$(this).parent().remove();
		});


		//show/hide my question relates to
		$('body').on('change', '#help-category', function () {
			var helpCategory = this.value;
			var $productInformation = $('.js-product-info');
			var $salesInformation = $('.js-sales-info');
			if (helpCategory == "sales") {
				$salesInformation.removeClass('hidden');
				$productInformation.addClass('hidden');
				$filesRequired.addClass('hidden');
			}
			else if(helpCategory =="other"){
				$productInformation.removeClass('hidden');
				$salesInformation.addClass('hidden');
				$filesRequired.addClass('hidden');
			}
			else{
				$productInformation.removeClass('hidden');
				$salesInformation.addClass('hidden');
				$filesRequired.removeClass('hidden');
			}
		});
	};

	let inputEventListeners = function () {
		$firstName.on('blur change', validateField);
		$lastName.on('blur change', validateField);
		$email.on('blur change', validateField);
		$address.on('blur change', validateField);
		$address2.on('blur change', validateField);
		$country.on('blur change', validateField);
		$city.on('blur change', validateField);
		if ($country.val() == "CAN") {
            $province.on('blur change', validateField);
        }
        else {
            $state.on('blur change', validateField);
        }	
		$postalCode.on('blur change', validateField);
		$phone.on('blur change', validateField);
		$originalOwner.on('blur change', validateField);
		$productCategory.on('blur change', validateField);
		$purchaseYear.on('blur change', validateField);
		$helpCategory.on('blur change', validateField);
		$currentlyBuy.on('blur change', validateField);
		$estimatedsales.on('blur change', validateField);
		$focusedOn.on('blur change', validateField);
		$InterestedIn.on('blur change', validateField);
		$productInterests.on('blur change', validateField);
		$questionComment.on('blur change', validateField);
		grecaptcha.ready(() => {
			grecaptcha.render( document.getElementById('g-recaptcha'), {
				callback: validateField
			});
		});		
	};	

	let submitEventListener = function () {
		$submit.on('click', function (e) {
			e.preventDefault();

			$submit.addClass('hidden');
			$pleaseWait.removeClass('hidden');

			$('.js-alert').addClass('hidden');
			let fileHasValue: boolean = uploadFiles && uploadFiles.length > 0;
			let stateProvince = $state.val()
			if ($country.val() == "CAN") {
			   stateProvince = $province.val();
			}
            if (formValidation.validateWrapperSubmit({
				constraints: $helpCategory.val() =="sales" ? salesConstraints : constraints,
				values: {
					'first-name': $firstName.val(),
					'last-name': $lastName.val(),
					email: $email.val(),
					address: $address.val(),
					address2: $address2.val(),
					country: $country.val(),
					city: $city.val(),
					'state': stateProvince,
					'postal-code': $postalCode.val(),
					phone: $phone.val(),
					'describe-you': $describeYou.val(),
					'original-owner': $originalOwner.filter(':checked').val(),
					'product-category': $productCategory.val(),
					'model': $model.val(),
					'purchase-year': $purchaseYear.val(),
					'help-category': $helpCategory.val(),
					'currently-buy': $currentlyBuy.filter(':checked').val(),
					'estimated-sales': $estimatedsales.val(),
					'focusedOn': $focusedOn.filter(':checked').val(),
					'productInterests': $productInterests.filter(':checked').val(),
					'interestedIn': $InterestedIn.val(),
					'question-comment': $questionComment.val(),
					'recaptcha-token': grecaptcha.getResponse()
				}
			}) && ((fileHasValue === true && !($helpCategory.val() =="sales")) || ($helpCategory.val() =="sales") || ($helpCategory.val() =="other")) ) {
			// Do nothing if ok

			} else {
				if(fileHasValue === false && !($helpCategory.val() =="sales") && !($helpCategory.val() =="other")){
					$(`<li>${uploadPhotoRequired}</li>`).appendTo($errorList);
				}
				$alertDangerFields.removeClass('hidden');
				$("html, body").animate({ scrollTop: 0 }, 500);
				$submit.removeClass('hidden');
				$pleaseWait.addClass('hidden');
				return;
			}
			let comment = "Question:" + $questionComment.val() + " ADDITIONAL INFORMATION::  "+" Fax No:" + $fax.val() + " User Type: " +$describeYou.val() +" Company Name: " + $companyName.val();

			if($helpCategory.val() =="sales")
			{
				let productInterests = $productInterests.filter(':checked').map(function(_, el) {
					return $(el).val();
				}).get();
				let focusedOn = $focusedOn.filter(':checked').map(function(_, el) {
					return $(el).val();
				}).get();
				 var additionalInfo = "Currently Buy:" + $currentlyBuy.filter(':checked').val()+ " Annual Sales:$" +$estimatedsales.val() + " Focused On:" + focusedOn + " Interested In:" +$InterestedIn.val() + " Product Interests:" + productInterests;
				 comment = comment +" " + additionalInfo;
			}
            $loadIndicator.addClass('state-loading');

			let data = new FormData();

			let contactInfo = JSON.stringify({
				FirstName: $firstName.val(),
				LastName: $lastName.val(),
				Email: $email.val(),
				Address1: $address.val(),
				Address2: $address2.val(),
				Country: $country.val(),
				City: $city.val(),
				State: stateProvince,
				PostalCode: $postalCode.val(),
				Phone: $phone.val()
			});

			data.append("ContactInfo", contactInfo);
			data.append("HelpCategory", $helpCategory.val().toString());
			data.append("OriginalOwner", $originalOwner.filter(':checked').val().toString());
			data.append("Question", comment);
			data.append("Product", $productCategory.val().toString());
			data.append("Model", $model.val().toString());
			data.append("PurchaseYear", $purchaseYear.val().toString());
		    data.append("File", fileInput.fileAtIndex($uploadPhoto[0], 0));

			$.ajax({
				url: POST_ASKAQUESTION,
				type: 'POST',
				dataType: 'json',
				data: data,
				processData: false,
				contentType: false // not json
			    })
				.done(function (data) {
					type ObjectKey = keyof typeof data;
					const caseNum = 'caseNumber' as ObjectKey;
					$('#case-number').text(data[caseNum]);
					// upload files
					if(uploadFiles.length >0)
					{
						attachFilesToCase(data[caseNum], $email.val());
					}

					$alertSuccess.removeClass('hidden');
					$aaqform.reset();
					formValidation.resetForm($form);
					$('.js-file-input-value').text('');	
					$("html, body").animate({ scrollTop: 0 }, 500);				

				})
				.fail(function (response) {
					$alertDanger
						.removeClass('hidden')
						.find('.alert__text').text(response.responseJSON.Message);
						$("html, body").animate({ scrollTop: 0 }, 500);
				})
				.always(function () {					
					$loadIndicator.removeClass('state-loading');
					$submit.removeClass('hidden');
					$pleaseWait.addClass('hidden');					
				})
		});
	};
	let countryChange = function () {$country.on('change',function () {
		if ($(this).val() == "CAN") {
			$("#divprovince").show();
			$("#divstate").hide();
		}
		else {
			$("#divprovince").hide();
			$("#divstate").show();
		}
	});
	};
		
	let attachFilesToCase = function (caseNumber, email) {
		let data = new FormData();
		data.append("CaseNumber", caseNumber);
		data.append("Email", email);
		data.append("Comment", "Uploaded new documents");

		for (var i = 0; i < uploadFiles.length; i++)
			data.append("Files" + i, uploadFiles[i]);

		$.ajax({
			url: POST_CASE_UPLOAD_FILE,
			type: 'POST',
			dataType: 'json',
			data: data,
			processData: false,
			contentType: false // not json
		})
			.done(function () {
				console.log('case files uploaded');
			})
			.fail(function (response) {
				console.log('case files upload failed')
			})

	};
	export const init = () => {
		setupHandlers();
		fileInput.init();
		inputEventListeners();
		submitEventListener();
		countryChange();
	};
}
document.addEventListener("DOMContentLoaded", () => {
	BHW.askAQuestion.init();
});

